import React from 'react';
import { Item, Button, Header } from 'semantic-ui-react';

const TaskItem = props => (
    <Item>
      <Item.Image size='small' src={`https://i3.ytimg.com/vi/${props.YoutubeId}/sddefault.jpg`} />
      <Item.Content verticalAlign='middle'>
        <Item.Header>{`Lesson #${props.Number}) ${props.Header}`}</Item.Header>
        <Item.Meta>{props.Description}</Item.Meta>
        <Item.Extra>
          <Button compact size='tiny' color="youtube" icon='youtube' content="Watch Video"  onClick={() => window.open(`https://www.youtube.com/watch?v=${props.YoutubeId}`)} />
          {
            props.SoundCloudId != null ?
              <Button compact size='tiny' color="google plus" icon="soundcloud" content="Listen to Audio" onClick={() => window.open(`https://soundcloud.com/ahl-al-quran-936655977/${props.SoundCloudId}`)}/>
            :
              null
          }
        </Item.Extra>
        <Item.Description>
          <Header content='Assignment' subheader={props.Assignment} />
        </Item.Description>
      </Item.Content>
    </Item>
)

export default TaskItem;
